<template>
	<el-tooltip v-bind="$props">
		<slot />
	</el-tooltip>
</template>

<script>
import { DmsBaseComponent } from '../common/base';

export default DmsBaseComponent.extend({
	name: 'DmsTooltip',
	props: {
		content: { type: String },
		effect: { type: String, default: 'light' },
		placement: { type: String },
		popperClass: { type: String },
	},
});
</script>
